import { useEffect, useRef } from 'react';
import type { IEventBus } from '@shore/types';

import { useIsMobile } from './use-is-mobile';
import EVENTS from '../constants/event-bus-events';

/**
 * Rotating a phone can cross the `md` breakpoint (many landscape widths are
 * wider than 768px), which mounts/unmounts the side menu in PageLayout just
 * like the desktop collapse toggle does — but silently, since nothing else
 * forwards resize/orientation changes to already-mounted micro apps. Emitting
 * the same event the toggle sends lets an app that relies on it to recompute
 * its layout learn about this transition too.
 */
export function useEmitMobileLayoutChange(eventBus: IEventBus): void {
  const isMobile = useIsMobile();
  const previousIsMobile = useRef(isMobile);

  useEffect(() => {
    if (previousIsMobile.current === isMobile) return;
    previousIsMobile.current = isMobile;

    eventBus.emit(
      isMobile ? EVENTS.SIDE_MENU_COLLAPSE : EVENTS.SIDE_MENU_EXPAND
    );
  }, [isMobile, eventBus]);
}
